var helperCreateGetObjects = require('./helperCreateGetObjects')

/**
  * 获取对象所有值
  *
  * @param {Object} obj 对象/数组
  * @return {Array}
  */
var values = helperCreateGetObjects('values', 0)

module.exports = values



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/values.js
// module id = KzkP
// module chunks = 137